import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";

// // Inspired by the former Facebook spinners.
// const useStylesFacebook = makeStyles((theme) => ({
//   root: {
//     position: "relative",
//   },
//   bottom: {
//     color: theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
//   },
//   top: {
//     color: "#1a90ff",
//     animationDuration: "550ms",
//     position: "absolute",
//     left: 0,
//   },
//   circle: {
//     strokeLinecap: "round",
//   },
// }));

// function FacebookCircularProgress(props) {
//   const classes = useStylesFacebook();

//   return (
//     <Box
//     position="relative"
//     display="inline-flex"
//     className={`circularprogress ${props.wrapclass}`}
//   >
//       <CircularProgress
//         variant="determinate"
//         className={classes.bottom}
//         size={64}
//         thickness={3}
//         {...props}
//         value={100}
//       />
//       <CircularProgress
//         variant="determinate"
//         className={`actual ${classes.top}`}
//         classes={{
//           circle: classes.circle,
//         }}
//         size={64}
//         thickness={3}
//         {...props}
//       />
//       <Box
//         top={0}
//         left={0}
//         bottom={0}
//         right={0}
//         position="absolute"
//         display="flex"
//         alignItems="center"
//         justifyContent="center"
//       >
//         <Typography
//           variant="caption"
//           component="div"
//           color="textSecondary"
//         >{`${Math.round(props.value)} ${props.signt==='yes'? "%":""}`}</Typography>
//       </Box>
//     </Box>
//   );
// }

// export default function CustomizedProgressBars(props) {
//   return <FacebookCircularProgress {...props} />;
// }


const useStyles = makeStyles(() => ({
  wrapper: {
    width: "100%",
  },
  labelRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  barContainer: {
    width: "100%",
    height: 8,
    borderRadius: 9999,
    backgroundColor: "#157F3C33",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    borderRadius: 9999,
    transition: "width 0.4s ease-in-out",
  },
}));

const CircularProgressWithLabel = ({ value = 0, signt = "", wrapclass = "", title }) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.wrapper} ${wrapclass}`}>
      <div className={classes.labelRow}>
        <Typography variant="body" className="text-gray-500 dark:text-gray-100 text-[16px] font-medium">{title}</Typography>
        <Typography variant="body" className="dark:text-[#94A3B8] text-[16px] font-medium">
          {Math.round(value)}{signt === "yes" ? "%" : ""}
        </Typography>
      </div>
      <div className={classes.barContainer}>
        <div
          className={`${classes.progressBar}`}
          style={{ width: `${value}%`, backgroundColor: wrapclass }}
        />
      </div>
    </Box>
  );
};

export default CircularProgressWithLabel;